import { Loader } from "@progress/kendo-react-indicators";
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import { fetchApi } from "services/api";
import CenterDivPanel from "../../../components/CenterDivPanel";

export type PayReadyToPostTrip = {
  TripNumber: string;
  DriverNumber: string | null;
  FirstPickupDateTime: string | null;
  EstimatedPayPeriodName: string | null;
  EstimatedPayPeriodPayDate: string | null;
  EstimatedPayPeriodTripsUpToDate: string | null;
  EstimatedPayPeriodPaperworkDeadlineDate: string | null;
};

type InvoicePayReadyToPostTripsResponse = {
  Trips: PayReadyToPostTrip[];
};

type PaperworkTripsTableProps = {
  orderId: string;
  paperworkDate: Date | null;
  paperworkTripsLoading: boolean;
  setPaperworkTripsLoading: (loading: boolean) => void;
};

const PaperworkTripsTable = ({
  orderId,
  paperworkDate,
  paperworkTripsLoading,
  setPaperworkTripsLoading,
}: PaperworkTripsTableProps) => {
  const [paperworkTrips, setPaperworkTrips] = useState<PayReadyToPostTrip[]>([]);

  useEffect(() => {
    setPaperworkTrips([]);

    if (!paperworkDate) return;

    setPaperworkTripsLoading(true);
    //const payloadDate = encodeURIComponent(paperworkDate.toISOString());

    fetchApi(`/api/Order/InvoicePayReadyToPostTrips/${orderId}`, { PaperworkCheckInDate: paperworkDate }, "POST")
      .then((response: InvoicePayReadyToPostTripsResponse) => {
        setPaperworkTrips(response?.Trips ?? []);
      })
      .catch((e) => {
        setPaperworkTrips([]);
        if (!e?.status) alert('Unable to load pay trips');
      })
      .finally(() => setPaperworkTripsLoading(false));
  }, [orderId, paperworkDate, setPaperworkTripsLoading]);

  return (
    <div className="mt-4">
      {paperworkTripsLoading && <CenterDivPanel>
        <Loader type="converging-spinner" />
      </CenterDivPanel>}
      <table className="table table-md table-striped mt-2">
        <thead>
          <tr className="text-center">
            <th>Trip Number</th>
            <th>Driver</th>
            <th>Pay First Pick Up Date</th>
            <th>Target Pay Period</th>
            <th>Checked In By</th>
            <th>Pay Date</th>
          </tr>
        </thead>
        <tbody>
          {paperworkTrips.length === 0 && (
            <tr className="text-center">
              <td colSpan={6} className="text-muted">No Driver Pay Trips Found</td>
            </tr>
          )}
          {paperworkTrips.map((trip) => (
            <tr key={trip.TripNumber} className="text-center">
              <td>{trip.TripNumber}</td>
              <td>{trip.DriverNumber ?? '-'}</td>
              <td>{trip.FirstPickupDateTime ? dayjs.utc(trip.FirstPickupDateTime).tz("America/New_York").format("MM/DD/YYYY") : "-"}</td>
              <td>{trip.EstimatedPayPeriodTripsUpToDate ? dayjs.utc(trip.EstimatedPayPeriodTripsUpToDate).tz("America/New_York").format("MM/DD/YYYY") : "-"} ({trip.EstimatedPayPeriodName ?? "-"})</td>
              <td>{trip.EstimatedPayPeriodPaperworkDeadlineDate ? dayjs.utc(trip.EstimatedPayPeriodPaperworkDeadlineDate).tz("America/New_York").format("MM/DD/YYYY") : "-"}</td>
              <td>{trip.EstimatedPayPeriodPayDate ? dayjs.utc(trip.EstimatedPayPeriodPayDate).tz("America/New_York").format("MM/DD/YYYY") : "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaperworkTripsTable;